import { SnackbarProps } from '@mui/material';

export type NotificationFunction = (
  message: string,
  options?: Omit<SnackbarProps, 'message'>,
) => void;

export enum NotificationType {
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
  DEFAULT = 'DEFAULT',
}

export type Notification = SnackbarProps & {
  type: NotificationType;
  key: number;
};
